// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"x0qsW","heading":"_24dBH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/EmptyNotice.css
// module id = 800
// module chunks = 0